export default __webpack_public_path__ + "media/images/portfolio/gallery-02-1200x814_original-58b3d1545d249bf34ef80be2e0b4441f.jpg";